Prism.languages.diff = {
  coord: [/^(?:\*{3}|-{3}|\+{3}).*$/m, /^@@.*@@$/m, /^\d+.*$/m],
  deleted: /^[-<].*$/m,
  inserted: /^[+>].*$/m,
  diff: {
    pattern: /^!(?!!).+$/m,
    alias: "important"
  }
};